import { PropertyBase } from './property.base';

export class ResidentialProperty extends PropertyBase {
  constructor(data?: any) {
    super(data);

    this.totalSurface = data ? data.totalSurface : 0;
  }

  totalSurface: number;
}
